import React from 'react';
import { getProduct, getAllProducts } from 'services/product';
import { useParams, useHistory } from 'react-router-dom';
import Accordion from '../Accordion/Categories';
import Content from '../Content';
import Product from 'services/product/models/product-interface';

const Component: React.FC = () => {
  const { id } =
    useParams<{
      id: string;
    }>();
  const history = useHistory();

  const [products, setProducts] = React.useState<Product[]>([]);
  const [productSelected, setProductSelected] = React.useState<Product>();

  React.useEffect(() => {
    (async () => {
      const localProducts = await getAllProducts();
      let localProduct;
      if (id === '1') {
        history.push(`/produtos/${localProducts[0].product_id}`);
      } else {
        localProduct = await getProduct(id);

        setProductSelected(localProduct);
      }

      setProducts(localProducts);
    })();
  }, [id]);

  return (
    <>
      <Accordion products={products} setProductSelected={setProductSelected}>
        <Content product={productSelected} />
      </Accordion>
    </>
  );
};

export default Component;
